import styled from 'styled-components'
import { border1 } from '@/theme/colors'

/** The rule above each of the modal's auto-saving sections. */
export const SectionDivider = styled.hr`
	border: none;
	border-top: 1px solid ${border1};
	margin: 20px 0;
`

export const ModalFooter = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
`
